import React, {useEffect, useState} from "react";
import ToggleSwitch from "../inputs/ToggleSwitch";

const PlanToggleSwitchRow = ({selectedDoNotRenew, setSelectedDoNotRenew}) => {
    return (
        <div className={'row'} data-testid={'planToggleSwitchRowDiv'}>
            <div className={'col-12'}>
                <ToggleSwitch text={i18n.payments.doNotRenew}
                              value={selectedDoNotRenew}
                              testid={'doNotRenewToggleSwitchInput'}
                              onClick={() => {
                                  setSelectedDoNotRenew(val => !val);
                              }}/>
            </div>
        </div>
    );
};

export default PlanToggleSwitchRow;